
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_18413_7115)"}},[_c('path',{attrs:{"d":"M13.503 2h-6.12c0 1.497 1.238 2.716 2.76 2.716h1.131v1.062c0 1.497 1.239 2.716 2.76 2.716V2.522a.517.517 0 00-.53-.522z","fill":"#2684FF"}}),_c('path',{attrs:{"d":"M10.478 4.994h-6.12c0 1.498 1.238 2.716 2.76 2.716H8.25v1.08c0 1.497 1.238 2.716 2.759 2.716v-5.99a.528.528 0 00-.53-.522z","fill":"url(#paint0_linear_18413_7115)"}}),_c('path',{attrs:{"d":"M7.454 8.006h-6.12c0 1.497 1.238 2.716 2.759 2.716h1.132v1.062c0 1.497 1.238 2.716 2.76 2.716V8.528a.528.528 0 00-.531-.522z","fill":"url(#paint1_linear_18413_7115)"}})]),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_18413_7115","x1":"10.879","y1":"5.01","x2":"8.319","y2":"7.691","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":".176","stop-color":"#0052CC"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0C66E4"}})]),_c('linearGradient',{attrs:{"id":"paint1_linear_18413_7115","x1":"8.024","y1":"8.026","x2":"5.062","y2":"10.954","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":".176","stop-color":"#0052CC"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#2684FF"}})]),_c('clipPath',{attrs:{"id":"clip0_18413_7115"}},[_c('rect',{attrs:{"fill":"#fff"}})])])])
          )
        }
      }
    